import { useState } from "react";

import { Card, FontIcon, PageLayout } from "@ezmid/components-library";
import { faLanguage } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import Select from "react-select";

import { useGetBackOfficeListLanguagesQuery } from "../../../api/languages.generated";
import { getLanguage } from "../../../hooks";
import { setLanguage as setLanguageToLocalStorage } from "../../../hooks/clientLanguage";

type LanguageValue = "en-GB" | "de-DE";
type LanguageLabel = "english" | "deutsch";

type LanguageOption = {
  value: LanguageValue;
  label: LanguageLabel;
};

export function UserSettingsPage() {
  const { i18n, t } = useTranslation();
  const { currentData } = useGetBackOfficeListLanguagesQuery();
  const remmapedOptions = currentData?.map(({ defaultLocale, label }) => {
    return {
      value: defaultLocale,
      label,
    };
  });
  const langFromLS = getLanguage();

  const [language, setLanguage] = useState<LanguageOption | null>();
  const defaultOption = {
    value: langFromLS,
    label: langFromLS === "en-GB" ? "english" : "deutsch",
  };

  return (
    <PageLayout title={t("app.settings")}>
      <div className="w-full min-w-full flex justify-start p-2">
        <div className="w-1/2 h-[calc(100%_-_182px)] overflow-hidden">
          <Card
            borderRadius="normal"
            hasHeader
            rounded="sm"
            size="fill"
            shadows="xl"
            headerIcon={
              <FontIcon
                width={16}
                height={16}
                marginRight={8}
                marginTop={4}
                customIcon={<FontAwesomeIcon icon={faLanguage} />}
              />
            }
            headerText={t("app.page.settings.language")}
          >
            <div className="p-4">
              <Select
                options={remmapedOptions as Array<LanguageOption>}
                defaultValue={defaultOption}
                value={language}
                onChange={(option) => {
                  setLanguage(option as LanguageOption);
                  i18n.changeLanguage(option?.value || "");
                  setLanguageToLocalStorage(option?.value || "en-GB");
                  window.location.reload();
                }}
              />
            </div>
          </Card>
        </div>
      </div>
    </PageLayout>
  );
}
